import { render, staticRenderFns } from "./therapist.vue?vue&type=template&id=25c4112e&"
import script from "./therapist.vue?vue&type=script&lang=js&"
export * from "./therapist.vue?vue&type=script&lang=js&"
import style0 from "./therapist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.5_@vue+compiler-sfc@3.5.44_babel-core@7.0.0-bridge.0_@babel+core@7.12.8_bab05b83ea19148beb1746204d3ff44c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25c4112e')) {
      api.createRecord('25c4112e', component.options)
    } else {
      api.reload('25c4112e', component.options)
    }
    module.hot.accept("./therapist.vue?vue&type=template&id=25c4112e&", function () {
      api.rerender('25c4112e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/therapist.vue"
export default component.exports